<template>
  <g>
    <path d="M0.246 0h6.213v2.259h-3.954v4.7h-2.259v-6.959z"></path>
    <path d="M17.754 0v6.376h-2.259v-4.117h-4.518v-2.259h6.778z"></path>
    <path d="M17.754 18h-6.213v-2.259h3.954v-4.7h2.259v6.959z"></path>
    <path d="M0.246 18v-6.376h2.259v4.117h4.518v2.259h-6.778z"></path>
  </g>
</template>
